import { ApolloClient, InMemoryCache } from "@apollo/client"
import { ApolloProvider } from "@apollo/client/react"
import { hydrateRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { createHttpApolloLink } from "~/common/create-http-apollo-link"
import { MarketingApp } from "~/marketing/marketing-app"

const rootEl = document.getElementById("react-root")
const apolloClient = new ApolloClient({
  link: createHttpApolloLink(),
  cache: new InMemoryCache(),
  defaultOptions: { mutate: { errorPolicy: "all" } },
})

if (rootEl) {
  const unsubscribeEmail = rootEl.dataset.unsubscribeEmail
  const unsubscribed = rootEl.dataset.unsubscribed === "true"

  hydrateRoot(
    rootEl,
    <BrowserRouter>
      <ApolloProvider client={apolloClient}>
        <MarketingApp unsubscribeEmail={unsubscribeEmail} unsubscribed={unsubscribed} />
      </ApolloProvider>
    </BrowserRouter>
  )
}
